export default "__VITE_ASSET__BJCi_9Rp__"